import { TournamentStatus } from '@okletsplay/core';

export const FINISHED_TOURNAMENT_STATUSES = [
  TournamentStatus.Finished,
  TournamentStatus.Canceled,
  TournamentStatus.Failed,
];
